// Import Firebase
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'
// Initialize Firebase
firebase.initializeApp({
    apiKey: "AIzaSyBeigUhhzRz1gficQIg8EdOn-gMmwVbaxE",
    authDomain: "velabahlekehighsite.firebaseapp.com",
    projectId: "velabahlekehighsite",
    storageBucket: "velabahlekehighsite.appspot.com",
    messagingSenderId: "584989866695",
    appId: "1:584989866695:web:7e5f6ce9bf1c57c2cd9ce2",
    measurementId: "G-PEWYD43L3G"
});
firebase.analytics();
// Utils
const au = firebase.auth()
export {
  au
}